<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/by4Afg/tc-custom/9781497671768.jpg?1734044445780" alt="This image is the cover for the book Death on the Diagonal, Crossword Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death on the Diagonal, Crossword Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>What’s an eight-letter word for <i>killjoy</i>? Find out in this devilishly clever crossword mystery featuring husband-and-wife sleuth team Belle Graham and Rosco Polycrates </b><br/><br/> Belle Graham hears it first from the gossip columnist for the <i>Evening Crier</i>, where Belle is resident crossword editor. Fire has destroyed one of the stables at King Wenstarin Farms, the multimillion-dollar corporation owned by the notorious Collins clan, and the barn manager lies in a coma. Did someone torch the place? That’s what Belle’s PI husband, Rosco Polycrates has been hired to find out.<br/><br/> Former Prohibition–era bootleggers, the Collinses live in a mansion that is more Newport, Rhode Island, than Newcastle, Massachusetts. Todd Collins, the seventy-four-year-old patriarch, is currently married to much-younger wife number three, his three children’s horsey stepmom from hell. But the family’s infamous infighting is about to morph into a nasty case of murder.<br/><br/> With a media circus heating up, a second homicide rocks the New England town. Now Belle has to solve some cryptic brainteasers before she becomes the next victim of a killer ready to ride off into the sunset . . . after burying Belle six feet down—and three across.<br/><br/> This ebook includes six crossword puzzles that can be downloaded as PDFs, with answers in the back of the book.<br/><br/><b><i>Death on the Diagonal </i></b><b>is the 8th book in the Crossword Mysteries, but you may enjoy reading the series in any order.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nero Blanc
      </h2>
      
      <p class="authorDescription body article">Nero Blanc is the pseudonym of Steve Zettler and Cordelia Frances Biddle, who are husband and wife and serious crossword buffs. Biddle is also the author of the Martha Beale historical mystery series, which is set in Philadelphia, Zettler and Biddle&rsquo;s hometown. Their website is www.crosswordmysteries.com.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bff2c7b2